import Vue from "vue";
import Router from "vue-router";
// eslint-disable-next-line no-unused-vars
import firebase from "firebase/app";
import "firebase/auth";
// eslint-disable-next-line no-unused-vars
import {store} from "./store/store";

Vue.use(Router);

const router = new Router({
  linkExactActiveClass: "active",
  // mode: "history",
  routes: [
    {
      path: "/",
      component: () => import("./layouts/guestLayouts/publicLayout"),
      props: {
        isBackend: false,
      },
      children: [
        {
          path: "/",
          name: "Eng Job fair",
          component: () => import("./views/jobfair/jobs"),
          meta: {
            allowAll: true
          }
        },
      ]
    },
    {
      path: "/company",
      component: () => import("./layouts/guestLayouts/publicLayout"),
      props: {
        isBackend: true,
        isCompany: true
      },
      children: [
        {
          path: "/company/information",
          name: "Company Information",
          component: () => import("./views/company/informationForm"),
          meta: {            requiresCompanyAuth: true
          }
        },
        {
          path: "/company/description",
          name: "Company Description",
          component: () => import("./views/company/descriptionForm"),
          meta: {
            requiresCompanyAuth: true
          }
        },
        {
          path: "/company/meeting",
          name: "Company Meeting",
          component: () => import("./views/company/meetingForm"),
          meta: {
            requiresCompanyAuth: true
          }
        },
      ]
    },
    {
      path: "/company",
      component: () => import("./layouts/guestLayouts/loginLayout"),
      children: [
        {
          path: "/company/login",
          name: "Company Login",
          component: () => import("./views/userAccess/login"),
          props: {
            isStudent: false,
            isCompany: true
          },
          meta: {
            requiresGuest: true
          }
        },
        {
          path: "/company/register",
          name: "Company Register",
          component: () => import("./views/userAccess/register"),
          meta: {
            requiresGuest: true
          }
        },
        {
          path: "/company/forgotPassword",
          name: "Forgot password",
          component: () => import("./views/userAccess/forgotPassword"),
          meta: {
            requiresGuest: true
          }
        },
        // {
        //   path: "/emailVerify",
        //   name: "Verify Email",
        //   component: () => import("./views/userAccess/emailVerify"),
        //   meta: {
        //     requiresVerified: true
        //   }
        // }
      ]
    },
    {
      path: "/student",
      component: () => import("./layouts/guestLayouts/loginLayout"),
      children: [
        {
          path: "/student/login",
          name: "Student Login",
          component: () => import("./views/userAccess/login"),
          props: {
            isStudent: true,
            isCompany: false,
            isUnder: false // only under maintained
          },
          meta: {
            requiresGuest: true
          }
        }
      ]
    },
    {
      path: "/student",
      component: () => import("./layouts/authLayouts/studentRegisterLayout"),
      children: [
        {
          path: "/student/register",
          name: "Student Register",
          component: () => import("./views/student/register"),
          props: {
            msg: "Your are student"
          },
          meta: {
            requiresStudentAuth: true
          }
        }
      ]
    },
    {
      path: "/staff",
      component: () => import("./layouts/authLayouts/staffLayout"),
      children: [
        {
          path: "/staff/request",
          name: "Staff Request",
          component: () => import("./views/staff/allRequest"),
          meta: {
            staffOnly: true
          }
        }
      ]
    },
    {
      path: "/admin",
      component: () => import("./layouts/authLayouts/adminLayout"),
      children: [
        {
          path: "/admin/dashboard",
          name: "Staff Dashboard",
          component: () => import("./views/admin/admin"),
          meta: {
            staffOnly: true
          }
        },
        {
          path: "/admin/editor/:uid",
          name: "Staff Editor",
          component: () => import("./views/admin/editor"),
          meta: {
            staffOnly: true
          }
        }
      ]

    }
  ],
  scrollBehavior: to => {
    if (to.hash) {
      return {
        selector: to.hash
      };
    }
    return {
      x: 0,
      y: 0
    };
  }
});

router.beforeEach((to, from, next) => {

  // const isVerified = firebase.auth().currentUser.e2mailVerified
  const isVerified = true

  if (to.matched.some(record => record.meta.requiresCompanyAuth)) {
    if (firebase.auth().currentUser) {
      if (isVerified) {
        next();
      } else if (!isVerified) {
        next("/emailVerify");
      } else {
        next("/company/login");
      }
    } else {
      next("/");
    }
  }
  else if (to.matched.some(record => record.meta.requiresVerified)) {
    if (firebase.auth().currentUser) {
      if (isVerified) {
        next("/company/information");
      }
      else if (!isVerified) {
        next();
      }
      else {
        next("/company/login");
      }
    }
    else {
      next("/");
    }
  }
  else if (to.matched.some(record => record.meta.requiresStudentAuth)) {
    if (store.state.ldap && store.state.ldap_token !== "" && !store.state.ldap_expire && store.state.ldap_status === "student") {
      next();
    } else {
      next("/")
    }
  } else if (to.matched.some(record => record.meta.allowAll)) {
    if (firebase.auth().currentUser) {
      if (!isVerified) {
        next("/emailVerify");
      } else {
        next();
      }
    } else {
      next();
    }
  } else if (to.matched.some(record => record.meta.staffOnly)) {
    if (store.state.ldap && store.state.ldap_token !== "" && !store.state.ldap_expire && store.state.ldap_status === "admin") {
      next();
    } else {
      next("/")
    }
  } else if (to.matched.some(record => record.meta.requiresGuest)) {
    if (firebase.auth().currentUser) {
      next("/company/information");
    } else if (store.state.ldap && store.state.ldap_token !== "" && !store.state.ldap_expire) {
      next("/");
    } else {
      next();
    }
  } else {
    next("/");
  }
});

export default router;